export const MAX_TITLE_LENGTH = 255;
export const DEFAULT_PRECISION = 2;

export const DRIVING_DISTANCE_RULE_CONDITION_PATH = 'travelling_distance_between_waypoints';
